import React, { useState } from 'react';
import { useNavigate, useParams } from 'react-router-dom';
import GameSetupShell, { LevelStart, RunHeader, TileGrid, useGameStats } from '../../components/Games2/GameSetupShell';

const LEVELS = [
  { id: 1, name: 'Level 1', description: 'Practice (Slow)', speed: 'slow', feedback: true, color: 'green', details: ['25 rounds per run', 'Slow speed (1.2 digits/sec)', 'Feedback after each round'] },
  { id: 2, name: 'Level 2', description: 'Practice (Fast)', speed: 'fast', feedback: true, color: 'yellow', details: ['25 rounds per run', 'High speed (1.6 digits/sec)', 'Feedback after each round'] },
  { id: 3, name: 'Level 3', description: 'Real Test Mode', speed: 'fast', feedback: false, color: 'rose', details: ['25 rounds per run', 'High speed (1.6 digits/sec)', 'No feedback', 'Real exam conditions'] },
];

const score = (r) => parseFloat(r.final_score) || 0;

const RMSSetup2 = () => {
  const { subjectId } = useParams();
  const navigate = useNavigate();
  const game = useGameStats('RMS', subjectId);
  const { stats } = game;
  const [level, setLevel] = useState(3);

  const start = () => {
    const l = LEVELS.find((x) => x.id === level);
    navigate(`/games/rms/${subjectId}/play`, { state: { level, speed: l.speed, feedback: l.feedback, subject: stats?.subject } });
  };

  return (
    <GameSetupShell
      code="RMS"
      name="Running Memory Span"
      description="Auditory memory span assessment game"
      game={game}
      heroStats={[
        { label: 'Runs', value: stats?.total_runs || 0 },
        { label: 'Best', value: stats?.best_score || 0 },
        { label: 'Average', value: stats?.average_score || 0 },
      ]}
      picker={<LevelStart levels={LEVELS} value={level} onChange={setLevel} onStart={start} />}
      runs={stats?.history || []}
      chart={{ series: [{ label: 'Average digits', color: '#10B981', value: score, main: true }], max: (runs) => Math.ceil(Math.max(7, ...runs.map(score))) }}
      renderRun={(run) => (
        <div className="space-y-4">
          <RunHeader run={run} level={run.level || 1} sub={run.speed === 'fast' ? 'Fast' : 'Slow'} score={score(run).toFixed(1)} scoreLabel="Average score" />
          {(run.rounds_data || []).length > 0 && (
            <TileGrid
              title="Round scores"
              items={run.rounds_data.map((r, i) => ({ label: `R${i + 1}`, value: r.score, sub: `${r.sequence_length || '?'} digits`, tone: r.score >= 7 ? 'good' : r.score >= 4 ? 'mid' : 'bad' }))}
            />
          )}
        </div>
      )}
    />
  );
};

export default RMSSetup2;
